import { render } from "./FaqBlock.vue?vue&type=template&id=18710025&scoped=true"
import script from "./FaqBlock.vue?vue&type=script&lang=js"
export * from "./FaqBlock.vue?vue&type=script&lang=js"

import "./FaqBlock.vue?vue&type=style&index=0&id=18710025&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18710025"]])

export default __exports__